 /* external production */
 const loginURL = 'https://fulcrum.partners.nvidia.com/external'
 const baseURL = 'https://fulcrum.partners.nvidia.com'
 const userURL = 'https://fulcrum.partners.nvidia.com'
 const USER_TYPE = 'external'
 const ENV = 'production'

/* internal production */
// const loginURL = 'https://hqnvae-lynx.nvidia.com'
// const baseURL = 'https://hqnvae-lynx.nvidia.com'
// const userURL = 'https://fulcrum.nvidia.com'
// const USER_TYPE = 'internal'
// const ENV = 'production'

/* dev */
// const loginURL = 'http://hqnvae-puma.nvidia.com'
// const baseURL = 'http://hqnvae-puma.nvidia.com'
// const userURL = 'http://hqnvae-puma.nvidia.com'
// const USER_TYPE = 'internal'
// const ENV = 'dev'

export {
  baseURL,
  loginURL,
  userURL,
  ENV,
  USER_TYPE
}

